// The current broadcast is persisted before /radio/now returns its ID. Read
// that post directly: search remains the archive, never a readiness signal.
export async function prependRadioHead<T extends { id: unknown }>(
    history: T[],
    snapshot: { now?: { playQuestId?: string } | null } | null,
    load: (id: string) => Promise<T | null>,
): Promise<T[]> {
    if (!snapshot) throw new Error('Radio station request failed')
    const id = snapshot.now?.playQuestId
    if (!id) return history
    const head = await load(id)
    if (!head || String(head.id) !== String(id)) throw new Error('Current radio post unavailable')
    return [head, ...history.filter(post => String(post.id) !== String(id))]
}
